export const EShapeFillDirection = wcardinal.ui.EShapeFillDirection;